import $ from 'jquery';
import common from './common';

import mathService from '../../Services/Math/math';

export default function (options) {
    let { container } = options,
        elementsMathService = mathService.elementsMath(mathService.constants.MATH_RENDERER_MATHJAX),
        $mathElements;

    common(options);

    $mathElements = $(container).find('math');

    if ($mathElements.length > 0) {
        elementsMathService.mathElement($mathElements);
    }
}
